import { Select, SelectTrigger, SelectValue } from "@/components/ui/select";
import { defaultNS, useTranslation } from "@/lib/i18n";

export const WaitingDependencyPresentation = ({
  testId,
}: {
  testId?: string;
}) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "features.formFactory.dynamicSelectField.error",
  });

  return (
    <Select disabled>
      <SelectTrigger
        className="w-full"
        data-testid={testId}
        data-role="form-field-input"
      >
        <SelectValue placeholder={t("selectDependencyFirst")} />
      </SelectTrigger>
    </Select>
  );
};
